import { createContext } from 'react'

import { type UseCarouselReturn } from './use-carousel'

export type CarouselContext = UseCarouselReturn

export const CarouselContext = createContext<CarouselContext>({} as CarouselContext)
